import React, { useState, useRef } from 'react';
import html2canvas from 'html2canvas';
import './App.css';

function App() {
  const [name, setName] = useState('');
  const [imageSrc, setImageSrc] = useState(null);
  const posterRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImageSrc(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const downloadPoster = () => {
    if (!posterRef.current) {
      alert("Poster not ready yet.");
      return;
    }

    html2canvas(posterRef.current, {
      backgroundColor: null,
      scale: window.devicePixelRatio || 2,
      useCORS: true,
      allowTaint: true,
      logging: false,
    })
      .then((canvas) => {
        const link = document.createElement('a');
        link.download = `WANTED_${name.trim() || 'UNKNOWN'}.png`;
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();
      })
      .catch((err) => {
        console.error("Download failed:", err);
        alert("Couldn't generate the image.\nTry a different photo or refresh.");
      });
  };

  // Random high bounty number
  const generateBounty = () => {
    const min = 5000000;
    const max = 500000000;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const bounty = generateBounty().toLocaleString();

  // ← Replace these with your real details
  const yourEmail = "nuelagafie@gmail.com";      // Change this
  const yourWhatsAppNumber = "2348035527091";     // Change this (country code, no + or spaces)

  return (
    <div className="container">
      <h1>One Piece Bounty Generator</h1>

      <div className="form">
        <label>
          Pirate Name / Alias:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value.toUpperCase())}
            placeholder="e.g. Monkey.D.Luffy"
            maxLength={32}
          />
        </label>

        <label>
          Upload Wanted Photo:
          <input type="file" accept="image/*" onChange={handleImageChange} />
        </label>

        <button 
          onClick={downloadPoster} 
          disabled={!imageSrc || !name.trim()}
        >
          Download WANTED Poster
        </button>

        {/* Email & WhatsApp icons – added here */}
        <div className="social-icons">
          <a
            href={`mailto:${yourEmail}?subject=Ik%20love%20the%20One%20Piece%20Bounty%20Poster!&body=Here's%20my%20custom%20poster:%20${encodeURIComponent(window.location.href)}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Email me"
            className="icon-link email"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
          </a>

          <a
            href={`https://wa.me/${yourWhatsAppNumber}?text=I%20love%20the%20One%20Piece%20Bounty%20Poster!%20${encodeURIComponent(window.location.href)}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Share on WhatsApp"
            className="icon-link whatsapp"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 2C6.488 2 2 6.488 2 12.05c0 2.122.57 4.193 1.652 6.01l-.001.002-.002.003-.001.001-.001.001 1.38 5.04 5.04-1.38c1.817.99 3.88 1.513 5.98 1.513h.005c5.562 0 10.05-4.488 10.05-10.05 0-2.68-1.045-5.2-2.94-7.095z"/>
            </svg>
          </a>
        </div>
      </div>

      <div className="poster-preview">
        <div ref={posterRef} className="wanted-poster">
          <div className="header">
            <h1>WANTED</h1>
          </div>

          <div className="image-frame">
            {imageSrc ? (
              <img 
                src={imageSrc} 
                alt="Wanted person" 
                className="wanted-image" 
                crossOrigin="anonymous"
              />
            ) : (
              <div className="placeholder">YOUR FACE HERE</div>
            )}
          </div>

          <div className="info">
            <div className="dead-or-alive">
              <span>~~~</span> DEAD OR ALIVE <span>~~~</span>
            </div>

            <h2 className="name">{name || "???????????????"}</h2>

            <div className="bounty">
              <span className="currency">¥</span>
              <span className="amount">{bounty}</span>
            </div>

            {/* Bottom section: Latin left + MARINE right */}
            <div className="bottom-section">
              <div className="latin-text">
                Mortuus vel vivus quaeritur; si visus, classem refer vel, si licet, pugna et praemium vindica.
              </div>
              <p className="footer">MARINE</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
